import { motion } from "framer-motion";

export const FadeIn = ({ children, delay = 0, y = 26, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.85, delay, ease: [0.2, 0.8, 0.2, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);
